import PropTypes from 'prop-types';

import { ByTypeProTypes } from './ByType/ByType.proptypes';

export const PriceDefaultProps = {
  price: {},
};

export const PricePropTypes = {
  price: PropTypes.shape({
    public_price: PropTypes.number, // TODO: To remove
    customer_price: PropTypes.number, // TODO: To remove
    tier_prices: PropTypes.arrayOf(PropTypes.shape({})), // TODO: To remove
    discount_price: PropTypes.number, // TODO: To remove
    discount_classes: PropTypes.arrayOf(PropTypes.string),
    weee_amount: PropTypes.number, // TODO: To remove
    invoice: PropTypes.shape({ ...ByTypeProTypes }),
    sale: PropTypes.shape({ ...ByTypeProTypes }),
  }),
};
